import React from 'react';
import { MenuItem, Tab, Tabs } from '@mui/material';

const ButtonsOptions = ({handleCloseNavMenu, handleChangeOption, pages, isMenu, numberOption, handleChangeNumberOption}) => {

  return (
    <>
     {!isMenu
        ? 
        (<Tabs
            value={numberOption}
            onChange={handleChangeNumberOption}
            indicatorColor='primary'
            textColor="inherit"
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              whiteSpace: 'nowrap',
              '& .MuiTabs-scrollButtons': {
                visibility: 'visible',  // Force the scroll buttons to be visible
              },
            }}
          >
          {pages.map((page) => (
            <Tab
              key={page}
              sx={{
                my: 2,
                padding: 0,
                color: 'white',
                fontWeight: 'bold',
                display: 'flex',
              }}
              onClick={() => {
                handleCloseNavMenu();
                handleChangeOption(page);
              }}
              label={page}
            />
          ))}
          </Tabs>)

        : pages.map((page) => (
            <MenuItem
              key={page}
              onClick={() => {
                handleCloseNavMenu();
                handleChangeOption(page);
              }}
              sx={{
                my: 2,
                color: 'primary',
                display: 'flex',
                backgroundColor: 'rgba(0, 0, 0, 0.03)',
              }}
            >
              {page}
            </MenuItem>
          ))}
    </>
  );
};

export default ButtonsOptions;